const MOBILE_VIEWPORT_MAX_WIDTH = 767

function isMobileViewport() {
  return window.innerWidth <= MOBILE_VIEWPORT_MAX_WIDTH
}

export function initBottomCvArea() {
  const bottomCvArea = document.getElementById('bottom_cv_area')
  if (!(bottomCvArea instanceof HTMLElement)) return

  const footer = document.getElementById('footer')
  let visible = null

  const sync = (updatePadding = false) => {
    const show = isMobileViewport() && window.scrollY >= 10
    if (visible === show && !updatePadding) return

    visible = show
    bottomCvArea.style.display = show ? 'block' : 'none'
    if (!(footer instanceof HTMLElement)) return

    if (show) {
      footer.style.paddingBottom = `${bottomCvArea.offsetHeight}px`
    } else {
      footer.style.removeProperty('padding-bottom')
    }
  }

  const refresh = () => sync(true)
  window.addEventListener('load', refresh)
  window.addEventListener('resize', refresh)
  bottomCvArea.addEventListener('htmx:oobAfterSwap', refresh)

  window.addEventListener('scroll', () => {
    sync()
  }, { passive: true })
}
